var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g0, _g1, _g10, _g11, _g12, _g13, _g14, _g15, _g16, _g17, _g18, _g19, _g20, _g21;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function Svg404Animation(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: "100%",
    width: "100%",
    viewBox: "0 0 591 420",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "i0"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(297.5,211)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "rotate(0)"
  }, /*#__PURE__*/React.createElement("animateTransform", {
    repeatCount: "indefinite",
    type: "rotate",
    attributeName: "transform",
    dur: "6.017s",
    begin: "0s",
    calcMode: "spline",
    values: "0; 0; 360",
    keyTimes: "0; 0.501385; 1",
    keySplines: "0 0 1 1; 0 0 1 1",
    fill: "freeze"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "scale(1,1) translate(0,0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "i0"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#f2f5ff",
    d: "M0,196C56.15,196,99.4,168.81,135.13,130.98C148.37,116.97,165.49,103.93,175.57,87.18C190.75,61.96,196,31.31,196,0C196,-31.31,195.08,-61.35,185.06,-87.1C177.11,-107.5,162.34,-124.85,145.64,-140.64C127.38,-157.9,101.84,-169.18,75.15,-178.91C50.5,-187.89,25.03,-196,0,-196C-21.38,-196,-42.55,-192.7,-61.38,-185.44C-82.12,-177.46,-100.24,-164.9,-117.56,-151.58C-143.16,-131.9,-159.74,-105.02,-173.59,-76.27C-184.97,-52.68,-196,-28.55,-196,0C-196,32.14,-193.87,64.58,-182.44,91.53C-174.07,111.25,-159.38,127.14,-143.65,142.22C-125.64,159.47,-100.53,170.05,-74.91,179.29C-50.46,188.12,-25.7,196,0,196Z"
  }))))))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.4,
    visibility: "visible",
    id: "i1"
  }, /*#__PURE__*/React.createElement("animate", {
    repeatCount: "indefinite",
    begin: "0s",
    calcMode: "discrete",
    dur: "6.017s",
    values: "visible; hidden; hidden",
    keyTimes: "0; 0.161009; 1",
    attributeName: "visibility"
  }), /*#__PURE__*/React.createElement("animate", {
    repeatCount: "indefinite",
    attributeName: "opacity",
    dur: "6.017s",
    begin: "0s",
    fill: "freeze",
    values: "0; 0; 0.4; 0.4; 0; 0",
    keyTimes: "0; 0.160665; 0.243767; 0.576177; 0.65928; 1",
    keySplines: "0 0 1 1; 0 0 1 1; 0 0 1 1; 0 0 1 1; 0 0 1 1",
    calcMode: "spline"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(237.862,184)"
  }, /*#__PURE__*/React.createElement("animateTransform", {
    repeatCount: "indefinite",
    type: "translate",
    attributeName: "transform",
    dur: "6.017s",
    begin: "0s",
    calcMode: "spline",
    values: "407.775 184; 407.775 184; 159.167 184; 159.167 184",
    keyTimes: "0; 0.160665; 0.65928; 1",
    keySplines: "0 0 1 1; 0 0 1 1; 0 0 1 1",
    fill: "freeze"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "scale(1,1) translate(0,14)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "i2"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#bfceff",
    d: "M18,-11.66C27.94,-11.66,36,-3.68,36,6.17C36,16.02,27.94,24,18,24C12.58,24,-5.55,24,-11.77,24C-25.15,24,-36,13.25,-36,0C-36,-13.25,-25.15,-24,-11.77,-24C-1.97,-24,6.47,-18.24,10.29,-9.94C12.63,-11.04,15.24,-11.66,18,-11.66Z"
  })))))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.373,
    visibility: "visible",
    id: "i3"
  }, /*#__PURE__*/React.createElement("animate", {
    repeatCount: "indefinite",
    begin: "0s",
    calcMode: "discrete",
    dur: "6.017s",
    values: "visible; hidden; hidden",
    keyTimes: "0; 0.080004; 1",
    attributeName: "visibility"
  }), /*#__PURE__*/React.createElement("animate", {
    repeatCount: "indefinite",
    attributeName: "opacity",
    dur: "6.017s",
    begin: "0s",
    fill: "freeze",
    values: "0; 0; 0.4; 0.4; 0; 0",
    keyTimes: "0; 0.080332; 0.163435; 0.495845; 0.578947; 1",
    keySplines: "0 0 1 1; 0 0 1 1; 0 0 1 1; 0 0 1 1; 0 0 1 1",
    calcMode: "spline"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(225.697,70)"
  }, /*#__PURE__*/React.createElement("animateTransform", {
    repeatCount: "indefinite",
    type: "translate",
    attributeName: "transform",
    dur: "6.017s",
    begin: "0s",
    calcMode: "spline",
    values: "426.453 70; 426.453 70; 188.731 70; 188.731 70",
    keyTimes: "0; 0.080332; 0.578947; 1",
    keySplines: "0 0 1 1; 0 0 1 1; 0 0 1 1",
    fill: "freeze"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "scale(1,1) translate(0,14)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "i4"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#bfceff",
    d: "M-18.76,17C-24.14,17,-28.5,12.65,-28.5,7.29C-28.5,1.92,-24.14,-2.43,-18.76,-2.43C-17.7,-2.43,-16.68,-2.26,-15.72,-1.95C-14.75,-10.42,-7.54,-17,1.22,-17C10.64,-17,18.27,-9.39,18.27,0C18.27,0.06,18.27,0.11,18.27,0.17C18.82,0.06,19.39,0,19.97,0C24.68,0,28.5,3.81,28.5,8.5C28.5,13.19,24.68,17,19.97,17C16.8,17,-15.25,17,-18.76,17Z"
  })))))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    opacity: 0,
    visibility: "hidden",
    id: "i5"
  }, /*#__PURE__*/React.createElement("animate", {
    repeatCount: "indefinite",
    attributeName: "opacity",
    dur: "6.017s",
    begin: "0s",
    fill: "freeze",
    values: "0; 0.4; 0.4; 0; 0",
    keyTimes: "0; 0.083103; 0.415512; 0.498615; 1",
    keySplines: "0 0 1 1; 0 0 1 1; 0 0 1 1; 0 0 1 1",
    calcMode: "spline"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(170.048,263)"
  }, /*#__PURE__*/React.createElement("animateTransform", {
    repeatCount: "indefinite",
    type: "translate",
    attributeName: "transform",
    dur: "6.017s",
    begin: "0s",
    calcMode: "spline",
    values: "346.675 263; 170.048 263; 170.048 263",
    keyTimes: "0; 0.498615; 1",
    keySplines: "0 0 1 1; 0 0 1 1",
    fill: "freeze"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "scale(1,1) translate(0,14)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "i6"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#bfceff",
    d: "M-48.48,26C-52.91,26,-56.5,22.34,-56.5,17.83C-56.5,13.32,-52.91,9.66,-48.48,9.66C-46.87,9.66,-45.36,10.14,-44.11,10.98C-44.02,2.85,-37.52,-3.71,-29.53,-3.71C-26.85,-3.71,-24.34,-2.98,-22.18,-1.7C-21.33,-15.26,-10.25,-26,3.28,-26C12.87,-26,21.22,-20.61,25.58,-12.64C28.65,-14.52,32.25,-15.6,36.09,-15.6C47.36,-15.6,56.5,-6.29,56.5,5.2C56.5,16.69,47.36,26,36.09,26C29.98,26,-44.95,26,-48.48,26Z"
  })))))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    opacity: 0,
    visibility: "hidden",
    id: "i2"
  }, /*#__PURE__*/React.createElement("animate", {
    repeatCount: "indefinite",
    begin: "0s",
    calcMode: "discrete",
    dur: "6.017s",
    values: "hidden; visible; hidden; hidden",
    keyTimes: "0; 0.161009; 0.662037; 1",
    attributeName: "visibility"
  }), /*#__PURE__*/React.createElement("animate", {
    repeatCount: "indefinite",
    attributeName: "opacity",
    dur: "6.017s",
    begin: "0s",
    fill: "freeze",
    values: "0; 0; 0.4; 0.4; 0",
    keyTimes: "0; 0.66205; 0.745153; 1; 1",
    keySplines: "0 0 1 1; 0 0 1 1; 0 0 1 1; 0 0 1 1",
    calcMode: "spline"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(407.775,184)"
  }, /*#__PURE__*/React.createElement("animateTransform", {
    repeatCount: "indefinite",
    type: "translate",
    attributeName: "transform",
    dur: "6.017s",
    begin: "0s",
    calcMode: "spline",
    values: "407.775 184; 407.775 184; 159.167 184",
    keyTimes: "0; 0.66205; 1",
    keySplines: "0 0 1 1; 0 0 1 1",
    fill: "freeze"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "scale(1,1) translate(0,14)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "i2"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#bfceff",
    d: "M18,-11.66C27.94,-11.66,36,-3.68,36,6.17C36,16.02,27.94,24,18,24C12.58,24,-5.55,24,-11.77,24C-25.15,24,-36,13.25,-36,0C-36,-13.25,-25.15,-24,-11.77,-24C-1.97,-24,6.47,-18.24,10.29,-9.94C12.63,-11.04,15.24,-11.66,18,-11.66Z"
  })))))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    opacity: 0,
    visibility: "hidden",
    id: "i4"
  }, /*#__PURE__*/React.createElement("animate", {
    repeatCount: "indefinite",
    begin: "0s",
    calcMode: "discrete",
    dur: "6.017s",
    values: "hidden; visible; hidden; hidden",
    keyTimes: "0; 0.080004; 0.582032; 1",
    attributeName: "visibility"
  }), /*#__PURE__*/React.createElement("animate", {
    repeatCount: "indefinite",
    attributeName: "opacity",
    dur: "6.017s",
    begin: "0s",
    fill: "freeze",
    values: "0; 0; 0.4; 0.4; 0",
    keyTimes: "0; 0.581717; 0.66482; 0.99723; 1",
    keySplines: "0 0 1 1; 0 0 1 1; 0 0 1 1; 0 0 1 1",
    calcMode: "spline"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(426.453,70)"
  }, /*#__PURE__*/React.createElement("animateTransform", {
    repeatCount: "indefinite",
    type: "translate",
    attributeName: "transform",
    dur: "6.017s",
    begin: "0s",
    calcMode: "spline",
    values: "426.453 70; 426.453 70; 188.731 70",
    keyTimes: "0; 0.581717; 1",
    keySplines: "0 0 1 1; 0 0 1 1",
    fill: "freeze"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "scale(1,1) translate(0,14)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "i4"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#bfceff",
    d: "M-18.76,17C-24.14,17,-28.5,12.65,-28.5,7.29C-28.5,1.92,-24.14,-2.43,-18.76,-2.43C-17.7,-2.43,-16.68,-2.26,-15.72,-1.95C-14.75,-10.42,-7.54,-17,1.22,-17C10.64,-17,18.27,-9.39,18.27,0C18.27,0.06,18.27,0.11,18.27,0.17C18.82,0.06,19.39,0,19.97,0C24.68,0,28.5,3.81,28.5,8.5C28.5,13.19,24.68,17,19.97,17C16.8,17,-15.25,17,-18.76,17Z"
  })))))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    opacity: 0,
    visibility: "visible",
    id: "i6"
  }, /*#__PURE__*/React.createElement("animate", {
    repeatCount: "indefinite",
    begin: "0s",
    calcMode: "discrete",
    dur: "6.017s",
    values: "visible; hidden; hidden",
    keyTimes: "0; 0.501028; 1",
    attributeName: "visibility"
  }), /*#__PURE__*/React.createElement("animate", {
    repeatCount: "indefinite",
    attributeName: "opacity",
    dur: "6.017s",
    begin: "0s",
    fill: "freeze",
    values: "0; 0; 0.4; 0.4; 0",
    keyTimes: "0; 0.501385; 0.584488; 0.916897; 1",
    keySplines: "0 0 1 1; 0 0 1 1; 0 0 1 1; 0 0 1 1",
    calcMode: "spline"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(346.675,263)"
  }, /*#__PURE__*/React.createElement("animateTransform", {
    repeatCount: "indefinite",
    type: "translate",
    attributeName: "transform",
    dur: "6.017s",
    begin: "0s",
    calcMode: "spline",
    values: "346.675 263; 346.675 263; 170.048 263",
    keyTimes: "0; 0.501385; 1",
    keySplines: "0 0 1 1; 0 0 1 1",
    fill: "freeze"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "scale(1,1) translate(0,14)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "i6"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#bfceff",
    d: "M-48.48,26C-52.91,26,-56.5,22.34,-56.5,17.83C-56.5,13.32,-52.91,9.66,-48.48,9.66C-46.87,9.66,-45.36,10.14,-44.11,10.98C-44.02,2.85,-37.52,-3.71,-29.53,-3.71C-26.85,-3.71,-24.34,-2.98,-22.18,-1.7C-21.33,-15.26,-10.25,-26,3.28,-26C12.87,-26,21.22,-20.61,25.58,-12.64C28.65,-14.52,32.25,-15.6,36.09,-15.6C47.36,-15.6,56.5,-6.29,56.5,5.2C56.5,16.69,47.36,26,36.09,26C29.98,26,-44.95,26,-48.48,26Z"
  })))))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    opacity: 0,
    visibility: "hidden",
    id: "i7"
  }, /*#__PURE__*/React.createElement("animate", {
    repeatCount: "indefinite",
    begin: "0s",
    calcMode: "discrete",
    dur: "6.017s",
    values: "hidden; visible; visible",
    keyTimes: "0; 0.659037; 1",
    attributeName: "visibility"
  }), /*#__PURE__*/React.createElement("animate", {
    repeatCount: "indefinite",
    attributeName: "opacity",
    dur: "6.017s",
    begin: "0s",
    fill: "freeze",
    values: "0; 0; 0.4; 0.4; 0",
    keyTimes: "0; 1; 1; 1; 1",
    keySplines: "0 0 1 1; 0 0 1 1; 0 0 1 1; 0 0 1 1",
    calcMode: "spline"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(407.775,184)"
  }, /*#__PURE__*/React.createElement("animateTransform", {
    repeatCount: "indefinite",
    type: "translate",
    attributeName: "transform",
    dur: "6.017s",
    begin: "0s",
    calcMode: "spline",
    values: "407.775 184; 407.775 184; 159.167 184",
    keyTimes: "0; 1; 1",
    keySplines: "0 0 1 1; 0 0 1 1",
    fill: "freeze"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "scale(1,1) translate(0,14)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "i2"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#bfceff",
    d: "M18,-11.66C27.94,-11.66,36,-3.68,36,6.17C36,16.02,27.94,24,18,24C12.58,24,-5.55,24,-11.77,24C-25.15,24,-36,13.25,-36,0C-36,-13.25,-25.15,-24,-11.77,-24C-1.97,-24,6.47,-18.24,10.29,-9.94C12.63,-11.04,15.24,-11.66,18,-11.66Z"
  })))))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    opacity: 0,
    visibility: "hidden",
    id: "i8"
  }, /*#__PURE__*/React.createElement("animate", {
    repeatCount: "indefinite",
    begin: "0s",
    calcMode: "discrete",
    dur: "6.017s",
    values: "hidden; visible; visible",
    keyTimes: "0; 0.579032; 1",
    attributeName: "visibility"
  }), /*#__PURE__*/React.createElement("animate", {
    repeatCount: "indefinite",
    attributeName: "opacity",
    dur: "6.017s",
    begin: "0s",
    fill: "freeze",
    values: "0; 0; 0.4; 0.4; 0",
    keyTimes: "0; 1; 1; 1; 1",
    keySplines: "0 0 1 1; 0 0 1 1; 0 0 1 1; 0 0 1 1",
    calcMode: "spline"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(426.453,70)"
  }, /*#__PURE__*/React.createElement("animateTransform", {
    repeatCount: "indefinite",
    type: "translate",
    attributeName: "transform",
    dur: "6.017s",
    begin: "0s",
    calcMode: "spline",
    values: "426.453 70; 426.453 70; 188.731 70",
    keyTimes: "0; 1; 1",
    keySplines: "0 0 1 1; 0 0 1 1",
    fill: "freeze"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "scale(1,1) translate(0,14)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "i4"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#bfceff",
    d: "M-18.76,17C-24.14,17,-28.5,12.65,-28.5,7.29C-28.5,1.92,-24.14,-2.43,-18.76,-2.43C-17.7,-2.43,-16.68,-2.26,-15.72,-1.95C-14.75,-10.42,-7.54,-17,1.22,-17C10.64,-17,18.27,-9.39,18.27,0C18.27,0.06,18.27,0.11,18.27,0.17C18.82,0.06,19.39,0,19.97,0C24.68,0,28.5,3.81,28.5,8.5C28.5,13.19,24.68,17,19.97,17C16.8,17,-15.25,17,-18.76,17Z"
  })))))), _g0 || (_g0 = /*#__PURE__*/React.createElement("g", {
    opacity: 0,
    visibility: "hidden",
    id: "i9"
  }, /*#__PURE__*/React.createElement("animate", {
    repeatCount: "indefinite",
    begin: "0s",
    calcMode: "discrete",
    dur: "6.017s",
    values: "hidden; visible; visible",
    keyTimes: "0; 0.499028; 1",
    attributeName: "visibility"
  }), /*#__PURE__*/React.createElement("animate", {
    repeatCount: "indefinite",
    attributeName: "opacity",
    dur: "6.017s",
    begin: "0s",
    fill: "freeze",
    values: "0; 0; 0.4; 0.4; 0",
    keyTimes: "0; 1; 1; 1; 1",
    keySplines: "0 0 1 1; 0 0 1 1; 0 0 1 1; 0 0 1 1",
    calcMode: "spline"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(346.675,263)"
  }, /*#__PURE__*/React.createElement("animateTransform", {
    repeatCount: "indefinite",
    type: "translate",
    attributeName: "transform",
    dur: "6.017s",
    begin: "0s",
    calcMode: "spline",
    values: "346.675 263; 346.675 263; 170.048 263",
    keyTimes: "0; 1; 1",
    keySplines: "0 0 1 1; 0 0 1 1",
    fill: "freeze"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "scale(1,1) translate(0,14)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "i6"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#bfceff",
    d: "M-48.48,26C-52.91,26,-56.5,22.34,-56.5,17.83C-56.5,13.32,-52.91,9.66,-48.48,9.66C-46.87,9.66,-45.36,10.14,-44.11,10.98C-44.02,2.85,-37.52,-3.71,-29.53,-3.71C-26.85,-3.71,-24.34,-2.98,-22.18,-1.7C-21.33,-15.26,-10.25,-26,3.28,-26C12.87,-26,21.22,-20.61,25.58,-12.64C28.65,-14.52,32.25,-15.6,36.09,-15.6C47.36,-15.6,56.5,-6.29,56.5,5.2C56.5,16.69,47.36,26,36.09,26C29.98,26,-44.95,26,-48.48,26Z"
  })))))), _g1 || (_g1 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,103.42,207.84)",
    id: "i10"
  }, /*#__PURE__*/React.createElement("g", {
    id: "i10"
  }, /*#__PURE__*/React.createElement("g", {
    id: "i11",
    fill: "#265cff"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M6.08,18.4C6.08,18.4,6.08,-50.08,6.08,-50.08C6.08,-50.08,-46.08,18.4,-46.08,18.4C-46.08,18.4,6.08,18.4,6.08,18.4ZM-89.92,60.64C-89.92,60.64,-89.92,9.44,-89.92,9.44C-89.92,9.44,-3.52,-103.84,-3.52,-103.84C-3.52,-103.84,56.64,-103.84,56.64,-103.84C56.64,-103.84,56.64,18.4,56.64,18.4C56.64,18.4,89.92,18.4,89.92,18.4C89.92,18.4,89.92,60.64,89.92,60.64C89.92,60.64,56.64,60.64,56.64,60.64C56.64,60.64,56.64,103.84,56.64,103.84C56.64,103.84,6.08,103.84,6.08,103.84C6.08,103.84,6.08,60.64,6.08,60.64C6.08,60.64,-89.92,60.64,-89.92,60.64Z"
  }))))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,493.56,207.84)",
    id: "i10"
  }, /*#__PURE__*/React.createElement("g", {
    id: "i10"
  }, /*#__PURE__*/React.createElement("g", {
    id: "i11",
    fill: "#265cff"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M6.08,18.4C6.08,18.4,6.08,-50.08,6.08,-50.08C6.08,-50.08,-46.08,18.4,-46.08,18.4C-46.08,18.4,6.08,18.4,6.08,18.4ZM-89.92,60.64C-89.92,60.64,-89.92,9.44,-89.92,9.44C-89.92,9.44,-3.52,-103.84,-3.52,-103.84C-3.52,-103.84,56.64,-103.84,56.64,-103.84C56.64,-103.84,56.64,18.4,56.64,18.4C56.64,18.4,89.92,18.4,89.92,18.4C89.92,18.4,89.92,60.64,89.92,60.64C89.92,60.64,56.64,60.64,56.64,60.64C56.64,60.64,56.64,103.84,56.64,103.84C56.64,103.84,6.08,103.84,6.08,103.84C6.08,103.84,6.08,60.64,6.08,60.64C6.08,60.64,-89.92,60.64,-89.92,60.64Z"
  }))))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    id: "i12"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(289,193)"
  }, /*#__PURE__*/React.createElement("animateTransform", {
    repeatCount: "indefinite",
    type: "translate",
    attributeName: "transform",
    dur: "6.017s",
    begin: "0s",
    calcMode: "spline",
    values: "289 193; 289 193; 309 133; 289 193; 299 133",
    keyTimes: "0; 0.501385; 1; 1; 1",
    keySplines: "0 0 1 1; 0.333 0 0.667 1; 0.333 0 0.667 1; 0.333 0 0.667 1",
    fill: "freeze"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(2.356)"
  }, /*#__PURE__*/React.createElement("animateTransform", {
    repeatCount: "indefinite",
    type: "rotate",
    attributeName: "transform",
    dur: "6.017s",
    begin: "0s",
    calcMode: "spline",
    values: "5; 5; -5; 5; -5; 5; -5",
    keyTimes: "0; 0.418283; 0.66482; 0.916898; 1; 1; 1",
    keySplines: "0 0 1 1; 0.333 0 0.667 1; 0.333 0 0.667 1; 0.333 0 0.667 1; 0.333 0 0.667 1; 0.333 0 0.667 1",
    fill: "freeze"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "scale(0.9,0.9)"
  }, /*#__PURE__*/React.createElement("animateTransform", {
    repeatCount: "indefinite",
    type: "scale",
    attributeName: "transform",
    dur: "6.017s",
    begin: "0s",
    calcMode: "spline",
    values: "0.9 0.9; 0.9 0.9; 1 1; 0.9 0.9; 1 1",
    keyTimes: "0; 0.501385; 1; 1; 1",
    keySplines: "0 0 1 1; 0.333 0 0.667 1; 0.333 0 0.667 1; 0.333 0 0.667 1",
    fill: "freeze"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-84.5,-76)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "i13"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(85.5,89.643) scale(1,1)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0,170.357)"
  }, /*#__PURE__*/React.createElement("animateTransform", {
    repeatCount: "indefinite",
    type: "translate",
    attributeName: "transform",
    dur: "6.017s",
    begin: "0s",
    calcMode: "spline",
    values: "0 170.357; 0 170.357; 0 170.357; 0 170.357",
    keyTimes: "0; 0.501385; 0.556787; 1",
    keySplines: "0 0 1 1; 0 0 1 1; 0 0 1 1",
    fill: "freeze"
  }), /*#__PURE__*/React.createElement("g", {
    id: "i13"
  }, /*#__PURE__*/React.createElement("g", {
    id: "i11",
    fill: "#6a79a8"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M5.38,-5C5.38,-5,3.65,-5,3.65,-5C3.58,-5,3.52,-4.96,3.47,-4.9C3.47,-4.9,-0.07,-0.02,-0.07,-0.02C-0.11,0.04,-0.17,0.08,-0.24,0.08C-0.3,0.08,-0.37,0.04,-0.41,-0.02C-0.41,-0.02,-2.73,-3.2,-2.73,-3.2C-2.77,-3.26,-2.83,-3.29,-2.9,-3.29C-2.9,-3.29,-4.23,-3.29,-4.23,-3.29C-4.29,-3.29,-4.35,-3.26,-4.4,-3.2C-4.4,-3.2,-5.47,-1.69,-5.47,-1.69C-5.5,-1.65,-5.51,-1.6,-5.49,-1.55C-5.47,-1.51,-5.43,-1.48,-5.39,-1.48C-5.39,-1.48,-4.44,-1.48,-4.44,-1.48C-4.44,-1.48,-3.51,-1.48,-3.51,-1.48C-3.51,-1.48,-0.46,2.91,-0.46,2.91C-0.42,2.97,-0.36,3,-0.29,3C-0.29,3,-0.19,3,-0.19,3C-0.13,3,-0.06,2.97,-0.02,2.91C-0.02,2.91,5.47,-4.77,5.47,-4.77C5.5,-4.81,5.51,-4.87,5.49,-4.92C5.47,-4.97,5.43,-5,5.38,-5ZM-3.95,-1C-3.95,-1,-4.5,-1,-4.5,-1C-4.5,-1,-4.5,4.73,-4.5,4.73C-4.5,4.88,-4.39,5,-4.25,5C-4.25,5,-2.75,5,-2.75,5C-2.61,5,-2.5,4.88,-2.5,4.73C-2.5,4.73,-2.5,0.94,-2.5,0.94C-2.5,0.94,-3.95,-1,-3.95,-1ZM2.5,1.36C2.5,1.36,2.5,4.76,2.5,4.76C2.5,4.89,2.61,5,2.75,5C2.75,5,4.25,5,4.25,5C4.39,5,4.5,4.89,4.5,4.76C4.5,4.76,4.5,-1,4.5,-1C4.5,-1,2.5,1.36,2.5,1.36Z"
  })))))))))))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    id: "i12"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(289,193)"
  }, /*#__PURE__*/React.createElement("animateTransform", {
    repeatCount: "indefinite",
    type: "translate",
    attributeName: "transform",
    dur: "6.017s",
    begin: "0s",
    calcMode: "spline",
    values: "289 193; 289 193; 309 133; 289 193; 299 133",
    keyTimes: "0; 0.501385; 1; 1; 1",
    keySplines: "0 0 1 1; 0.333 0 0.667 1; 0.333 0 0.667 1; 0.333 0 0.667 1",
    fill: "freeze"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(2.356)"
  }, /*#__PURE__*/React.createElement("animateTransform", {
    repeatCount: "indefinite",
    type: "rotate",
    attributeName: "transform",
    dur: "6.017s",
    begin: "0s",
    calcMode: "spline",
    values: "5; 5; -5; 5; -5; 5; -5",
    keyTimes: "0; 0.418283; 0.66482; 0.916898; 1; 1; 1",
    keySplines: "0 0 1 1; 0.333 0 0.667 1; 0.333 0 0.667 1; 0.333 0 0.667 1; 0.333 0 0.667 1; 0.333 0 0.667 1",
    fill: "freeze"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "scale(0.9,0.9)"
  }, /*#__PURE__*/React.createElement("animateTransform", {
    repeatCount: "indefinite",
    type: "scale",
    attributeName: "transform",
    dur: "6.017s",
    begin: "0s",
    calcMode: "spline",
    values: "0.9 0.9; 0.9 0.9; 1 1; 0.9 0.9; 1 1",
    keyTimes: "0; 0.501385; 1; 1; 1",
    keySplines: "0 0 1 1; 0.333 0 0.667 1; 0.333 0 0.667 1; 0.333 0 0.667 1",
    fill: "freeze"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-84.5,-76)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,37.295,178.645)",
    id: "i14"
  }, /*#__PURE__*/React.createElement("g", {
    id: "i14"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#6a79a8",
    d: "M28.143,63.009C27.653,63.009,27.183,62.729,26.963,62.259C26.963,62.259,-29.307,-61.181,-29.307,-61.181C-29.607,-61.831,-29.317,-62.601,-28.677,-62.891C-28.027,-63.191,-27.257,-62.901,-26.967,-62.251C-26.967,-62.251,29.313,61.189,29.313,61.189C29.603,61.829,29.323,62.599,28.673,62.899C28.503,62.969,28.313,63.009,28.143,63.009"
  }))))))))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    id: "i12"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(289,193)"
  }, /*#__PURE__*/React.createElement("animateTransform", {
    repeatCount: "indefinite",
    type: "translate",
    attributeName: "transform",
    dur: "6.017s",
    begin: "0s",
    calcMode: "spline",
    values: "289 193; 289 193; 309 133; 289 193; 299 133",
    keyTimes: "0; 0.501385; 1; 1; 1",
    keySplines: "0 0 1 1; 0.333 0 0.667 1; 0.333 0 0.667 1; 0.333 0 0.667 1",
    fill: "freeze"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(2.356)"
  }, /*#__PURE__*/React.createElement("animateTransform", {
    repeatCount: "indefinite",
    type: "rotate",
    attributeName: "transform",
    dur: "6.017s",
    begin: "0s",
    calcMode: "spline",
    values: "5; 5; -5; 5; -5; 5; -5",
    keyTimes: "0; 0.418283; 0.66482; 0.916898; 1; 1; 1",
    keySplines: "0 0 1 1; 0.333 0 0.667 1; 0.333 0 0.667 1; 0.333 0 0.667 1; 0.333 0 0.667 1; 0.333 0 0.667 1",
    fill: "freeze"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "scale(0.9,0.9)"
  }, /*#__PURE__*/React.createElement("animateTransform", {
    repeatCount: "indefinite",
    type: "scale",
    attributeName: "transform",
    dur: "6.017s",
    begin: "0s",
    calcMode: "spline",
    values: "0.9 0.9; 0.9 0.9; 1 1; 0.9 0.9; 1 1",
    keyTimes: "0; 0.501385; 1; 1; 1",
    keySplines: "0 0 1 1; 0.333 0 0.667 1; 0.333 0 0.667 1; 0.333 0 0.667 1",
    fill: "freeze"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-84.5,-76)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,88.412,143.098)",
    id: "i15"
  }, /*#__PURE__*/React.createElement("g", {
    id: "i15"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#6a79a8",
    d: "M-3.674,20.789C-13.224,20.789,-22.634,19.139,-31.454,15.839C-44.734,10.869,-56.494,2.699,-65.454,-7.791C-67.094,-9.721,-68.674,-11.751,-70.154,-13.821C-70.564,-14.401,-70.434,-15.201,-69.854,-15.621C-69.274,-16.031,-68.464,-15.901,-68.054,-15.321C-66.624,-13.311,-65.084,-11.341,-63.494,-9.471C-54.814,0.689,-43.424,8.599,-30.544,13.419C-13.294,19.879,6.306,19.799,24.646,13.209C42.346,6.849,57.756,-5.031,68.036,-20.221C68.436,-20.811,69.236,-20.971,69.826,-20.571C70.416,-20.171,70.576,-19.371,70.176,-18.781C59.586,-3.131,43.736,9.089,25.516,15.639C15.966,19.069,6.076,20.789,-3.674,20.789"
  }))))))))), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    id: "i12"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(289,193)"
  }, /*#__PURE__*/React.createElement("animateTransform", {
    repeatCount: "indefinite",
    type: "translate",
    attributeName: "transform",
    dur: "6.017s",
    begin: "0s",
    calcMode: "spline",
    values: "289 193; 289 193; 309 133; 289 193; 299 133",
    keyTimes: "0; 0.501385; 1; 1; 1",
    keySplines: "0 0 1 1; 0.333 0 0.667 1; 0.333 0 0.667 1; 0.333 0 0.667 1",
    fill: "freeze"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(2.356)"
  }, /*#__PURE__*/React.createElement("animateTransform", {
    repeatCount: "indefinite",
    type: "rotate",
    attributeName: "transform",
    dur: "6.017s",
    begin: "0s",
    calcMode: "spline",
    values: "5; 5; -5; 5; -5; 5; -5",
    keyTimes: "0; 0.418283; 0.66482; 0.916898; 1; 1; 1",
    keySplines: "0 0 1 1; 0.333 0 0.667 1; 0.333 0 0.667 1; 0.333 0 0.667 1; 0.333 0 0.667 1; 0.333 0 0.667 1",
    fill: "freeze"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "scale(0.9,0.9)"
  }, /*#__PURE__*/React.createElement("animateTransform", {
    repeatCount: "indefinite",
    type: "scale",
    attributeName: "transform",
    dur: "6.017s",
    begin: "0s",
    calcMode: "spline",
    values: "0.9 0.9; 0.9 0.9; 1 1; 0.9 0.9; 1 1",
    keyTimes: "0; 0.501385; 1; 1; 1",
    keySplines: "0 0 1 1; 0.333 0 0.667 1; 0.333 0 0.667 1; 0.333 0 0.667 1",
    fill: "freeze"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-84.5,-76)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,111.474,197.678)",
    id: "i16"
  }, /*#__PURE__*/React.createElement("g", {
    id: "i16"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#6a79a8",
    d: "M-15.922,75.368C-15.922,75.368,-36.382,75.368,-36.382,75.368C-40.662,75.368,-44.252,72.158,-44.722,67.898C-44.722,67.898,-47.322,44.438,-47.322,44.438C-47.402,43.738,-46.892,43.098,-46.182,43.018C-45.482,42.938,-44.842,43.448,-44.762,44.158C-44.762,44.158,-42.162,67.608,-42.162,67.608C-41.832,70.568,-39.352,72.788,-36.382,72.788C-36.382,72.788,-15.922,72.788,-15.922,72.788C-13.192,72.788,-10.942,70.748,-10.672,68.038C-10.672,68.038,-8.172,42.558,-8.172,42.558C-8.162,42.418,-8.122,42.288,-8.062,42.158C-8.062,42.158,44.868,-74.612,44.868,-74.612C45.158,-75.262,45.928,-75.552,46.578,-75.252C47.218,-74.962,47.508,-74.202,47.218,-73.552C47.218,-73.552,-5.632,43.028,-5.632,43.028C-5.632,43.028,-8.102,68.288,-8.102,68.288C-8.502,72.328,-11.862,75.368,-15.922,75.368"
  }))))))))), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    id: "i12"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(289,193)"
  }, /*#__PURE__*/React.createElement("animateTransform", {
    repeatCount: "indefinite",
    type: "translate",
    attributeName: "transform",
    dur: "6.017s",
    begin: "0s",
    calcMode: "spline",
    values: "289 193; 289 193; 309 133; 289 193; 299 133",
    keyTimes: "0; 0.501385; 1; 1; 1",
    keySplines: "0 0 1 1; 0.333 0 0.667 1; 0.333 0 0.667 1; 0.333 0 0.667 1",
    fill: "freeze"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(2.356)"
  }, /*#__PURE__*/React.createElement("animateTransform", {
    repeatCount: "indefinite",
    type: "rotate",
    attributeName: "transform",
    dur: "6.017s",
    begin: "0s",
    calcMode: "spline",
    values: "5; 5; -5; 5; -5; 5; -5",
    keyTimes: "0; 0.418283; 0.66482; 0.916898; 1; 1; 1",
    keySplines: "0 0 1 1; 0.333 0 0.667 1; 0.333 0 0.667 1; 0.333 0 0.667 1; 0.333 0 0.667 1; 0.333 0 0.667 1",
    fill: "freeze"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "scale(0.9,0.9)"
  }, /*#__PURE__*/React.createElement("animateTransform", {
    repeatCount: "indefinite",
    type: "scale",
    attributeName: "transform",
    dur: "6.017s",
    begin: "0s",
    calcMode: "spline",
    values: "0.9 0.9; 0.9 0.9; 1 1; 0.9 0.9; 1 1",
    keyTimes: "0; 0.501385; 1; 1; 1",
    keySplines: "0 0 1 1; 0.333 0 0.667 1; 0.333 0 0.667 1; 0.333 0 0.667 1",
    fill: "freeze"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-84.5,-76)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,85.009,241.978)",
    id: "i17"
  }, /*#__PURE__*/React.createElement("g", {
    id: "i17"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#6a79a8",
    d: "M0.004,10.001C-11.696,10.001,-20.866,5.611,-20.866,0.001C-20.866,-5.609,-11.696,-9.999,0.004,-9.999C0.714,-9.999,1.294,-9.419,1.294,-8.709C1.294,-7.999,0.714,-7.419,0.004,-7.419C-8.646,-7.419,-18.286,-4.369,-18.286,0.001C-18.286,4.371,-8.646,7.421,0.004,7.421C8.654,7.421,18.284,4.371,18.284,0.001C18.284,-2.139,15.574,-4.359,11.204,-5.789C10.524,-6.009,10.154,-6.739,10.374,-7.419C10.594,-8.099,11.324,-8.459,12.004,-8.239C17.634,-6.399,20.864,-3.389,20.864,0.001C20.864,5.611,11.704,10.001,0.004,10.001"
  }))))))))), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    id: "i12"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(289,193)"
  }, /*#__PURE__*/React.createElement("animateTransform", {
    repeatCount: "indefinite",
    type: "translate",
    attributeName: "transform",
    dur: "6.017s",
    begin: "0s",
    calcMode: "spline",
    values: "289 193; 289 193; 309 133; 289 193; 299 133",
    keyTimes: "0; 0.501385; 1; 1; 1",
    keySplines: "0 0 1 1; 0.333 0 0.667 1; 0.333 0 0.667 1; 0.333 0 0.667 1",
    fill: "freeze"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(2.356)"
  }, /*#__PURE__*/React.createElement("animateTransform", {
    repeatCount: "indefinite",
    type: "rotate",
    attributeName: "transform",
    dur: "6.017s",
    begin: "0s",
    calcMode: "spline",
    values: "5; 5; -5; 5; -5; 5; -5",
    keyTimes: "0; 0.418283; 0.66482; 0.916898; 1; 1; 1",
    keySplines: "0 0 1 1; 0.333 0 0.667 1; 0.333 0 0.667 1; 0.333 0 0.667 1; 0.333 0 0.667 1; 0.333 0 0.667 1",
    fill: "freeze"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "scale(0.9,0.9)"
  }, /*#__PURE__*/React.createElement("animateTransform", {
    repeatCount: "indefinite",
    type: "scale",
    attributeName: "transform",
    dur: "6.017s",
    begin: "0s",
    calcMode: "spline",
    values: "0.9 0.9; 0.9 0.9; 1 1; 0.9 0.9; 1 1",
    keyTimes: "0; 0.501385; 1; 1; 1",
    keySplines: "0 0 1 1; 0.333 0 0.667 1; 0.333 0 0.667 1; 0.333 0 0.667 1",
    fill: "freeze"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-84.5,-76)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,73.608,199.403)",
    id: "i18"
  }, /*#__PURE__*/React.createElement("g", {
    id: "i18"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#6a79a8",
    d: "M5.948,35.153C5.338,35.153,4.798,34.713,4.678,34.093C4.678,34.093,-7.222,-33.647,-7.222,-33.647C-7.342,-34.347,-6.872,-35.017,-6.172,-35.137C-5.482,-35.257,-4.802,-34.797,-4.682,-34.087C-4.682,-34.087,7.218,33.643,7.218,33.643C7.348,34.343,6.878,35.013,6.178,35.133C6.098,35.153,6.028,35.153,5.948,35.153"
  }))))))))), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", {
    id: "i12"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(289,193)"
  }, /*#__PURE__*/React.createElement("animateTransform", {
    repeatCount: "indefinite",
    type: "translate",
    attributeName: "transform",
    dur: "6.017s",
    begin: "0s",
    calcMode: "spline",
    values: "289 193; 289 193; 309 133; 289 193; 299 133",
    keyTimes: "0; 0.501385; 1; 1; 1",
    keySplines: "0 0 1 1; 0.333 0 0.667 1; 0.333 0 0.667 1; 0.333 0 0.667 1",
    fill: "freeze"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(2.356)"
  }, /*#__PURE__*/React.createElement("animateTransform", {
    repeatCount: "indefinite",
    type: "rotate",
    attributeName: "transform",
    dur: "6.017s",
    begin: "0s",
    calcMode: "spline",
    values: "5; 5; -5; 5; -5; 5; -5",
    keyTimes: "0; 0.418283; 0.66482; 0.916898; 1; 1; 1",
    keySplines: "0 0 1 1; 0.333 0 0.667 1; 0.333 0 0.667 1; 0.333 0 0.667 1; 0.333 0 0.667 1; 0.333 0 0.667 1",
    fill: "freeze"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "scale(0.9,0.9)"
  }, /*#__PURE__*/React.createElement("animateTransform", {
    repeatCount: "indefinite",
    type: "scale",
    attributeName: "transform",
    dur: "6.017s",
    begin: "0s",
    calcMode: "spline",
    values: "0.9 0.9; 0.9 0.9; 1 1; 0.9 0.9; 1 1",
    keyTimes: "0; 0.501385; 1; 1; 1",
    keySplines: "0 0 1 1; 0.333 0 0.667 1; 0.333 0 0.667 1; 0.333 0 0.667 1",
    fill: "freeze"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-84.5,-76)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,93.293,208.044)",
    id: "i19"
  }, /*#__PURE__*/React.createElement("g", {
    id: "i19"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#6a79a8",
    d: "M-4.88,43.802C-4.93,43.802,-4.98,43.792,-5.03,43.792C-5.74,43.712,-6.24,43.072,-6.16,42.362C-6.16,42.362,3.6,-42.658,3.6,-42.658C3.68,-43.368,4.32,-43.868,5.03,-43.788C5.74,-43.708,6.24,-43.068,6.16,-42.358C6.16,-42.358,-3.6,42.652,-3.6,42.652C-3.68,43.312,-4.23,43.802,-4.88,43.802"
  }))))))))), _g18 || (_g18 = /*#__PURE__*/React.createElement("g", {
    id: "i12"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(289,193)"
  }, /*#__PURE__*/React.createElement("animateTransform", {
    repeatCount: "indefinite",
    type: "translate",
    attributeName: "transform",
    dur: "6.017s",
    begin: "0s",
    calcMode: "spline",
    values: "289 193; 289 193; 309 133; 289 193; 299 133",
    keyTimes: "0; 0.501385; 1; 1; 1",
    keySplines: "0 0 1 1; 0.333 0 0.667 1; 0.333 0 0.667 1; 0.333 0 0.667 1",
    fill: "freeze"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(2.356)"
  }, /*#__PURE__*/React.createElement("animateTransform", {
    repeatCount: "indefinite",
    type: "rotate",
    attributeName: "transform",
    dur: "6.017s",
    begin: "0s",
    calcMode: "spline",
    values: "5; 5; -5; 5; -5; 5; -5",
    keyTimes: "0; 0.418283; 0.66482; 0.916898; 1; 1; 1",
    keySplines: "0 0 1 1; 0.333 0 0.667 1; 0.333 0 0.667 1; 0.333 0 0.667 1; 0.333 0 0.667 1; 0.333 0 0.667 1",
    fill: "freeze"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "scale(0.9,0.9)"
  }, /*#__PURE__*/React.createElement("animateTransform", {
    repeatCount: "indefinite",
    type: "scale",
    attributeName: "transform",
    dur: "6.017s",
    begin: "0s",
    calcMode: "spline",
    values: "0.9 0.9; 0.9 0.9; 1 1; 0.9 0.9; 1 1",
    keyTimes: "0; 0.501385; 1; 1; 1",
    keySplines: "0 0 1 1; 0.333 0 0.667 1; 0.333 0 0.667 1; 0.333 0 0.667 1",
    fill: "freeze"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-84.5,-76)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,84.811,84.521)",
    id: "i20"
  }, /*#__PURE__*/React.createElement("g", {
    id: "i20"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#265cff",
    d: "M83.923,0.075C85.243,56.635,22.893,98.825,-29.647,79.155C-42.537,74.335,-54.177,66.365,-63.127,55.885C-82.097,33.655,-89.417,2.125,-79.567,-25.735C-60.657,-79.195,11.603,-104.405,55.373,-64.445C73.483,-47.925,83.373,-23.895,83.923,0.075"
  }))))))))), _g19 || (_g19 = /*#__PURE__*/React.createElement("g", {
    id: "i12"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(289,193)"
  }, /*#__PURE__*/React.createElement("animateTransform", {
    repeatCount: "indefinite",
    type: "translate",
    attributeName: "transform",
    dur: "6.017s",
    begin: "0s",
    calcMode: "spline",
    values: "289 193; 289 193; 309 133; 289 193; 299 133",
    keyTimes: "0; 0.501385; 1; 1; 1",
    keySplines: "0 0 1 1; 0.333 0 0.667 1; 0.333 0 0.667 1; 0.333 0 0.667 1",
    fill: "freeze"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(2.356)"
  }, /*#__PURE__*/React.createElement("animateTransform", {
    repeatCount: "indefinite",
    type: "rotate",
    attributeName: "transform",
    dur: "6.017s",
    begin: "0s",
    calcMode: "spline",
    values: "5; 5; -5; 5; -5; 5; -5",
    keyTimes: "0; 0.418283; 0.66482; 0.916898; 1; 1; 1",
    keySplines: "0 0 1 1; 0.333 0 0.667 1; 0.333 0 0.667 1; 0.333 0 0.667 1; 0.333 0 0.667 1; 0.333 0 0.667 1",
    fill: "freeze"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "scale(0.9,0.9)"
  }, /*#__PURE__*/React.createElement("animateTransform", {
    repeatCount: "indefinite",
    type: "scale",
    attributeName: "transform",
    dur: "6.017s",
    begin: "0s",
    calcMode: "spline",
    values: "0.9 0.9; 0.9 0.9; 1 1; 0.9 0.9; 1 1",
    keyTimes: "0; 0.501385; 1; 1; 1",
    keySplines: "0 0 1 1; 0.333 0 0.667 1; 0.333 0 0.667 1; 0.333 0 0.667 1",
    fill: "freeze"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-84.5,-76)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,107.501,103.25)",
    opacity: 0.3,
    id: "i21"
  }, /*#__PURE__*/React.createElement("g", {
    id: "i21"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#1f41b3",
    d: "M-27.938,51.374C-36.838,51.374,-44.058,44.154,-44.058,35.254C-44.058,26.344,-36.838,19.124,-27.938,19.124C-6.018,19.124,11.822,1.274,11.822,-20.656C11.822,-24.186,11.362,-27.686,10.452,-31.046C8.142,-39.646,13.232,-48.496,21.822,-50.816C30.422,-53.136,39.262,-48.046,41.582,-39.446C43.222,-33.346,44.062,-27.026,44.062,-20.656C44.062,19.064,11.762,51.374,-27.938,51.374"
  }))))))))), _g20 || (_g20 = /*#__PURE__*/React.createElement("g", {
    id: "i12"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(289,193)"
  }, /*#__PURE__*/React.createElement("animateTransform", {
    repeatCount: "indefinite",
    type: "translate",
    attributeName: "transform",
    dur: "6.017s",
    begin: "0s",
    calcMode: "spline",
    values: "289 193; 289 193; 309 133; 289 193; 299 133",
    keyTimes: "0; 0.501385; 1; 1; 1",
    keySplines: "0 0 1 1; 0.333 0 0.667 1; 0.333 0 0.667 1; 0.333 0 0.667 1",
    fill: "freeze"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(2.356)"
  }, /*#__PURE__*/React.createElement("animateTransform", {
    repeatCount: "indefinite",
    type: "rotate",
    attributeName: "transform",
    dur: "6.017s",
    begin: "0s",
    calcMode: "spline",
    values: "5; 5; -5; 5; -5; 5; -5",
    keyTimes: "0; 0.418283; 0.66482; 0.916898; 1; 1; 1",
    keySplines: "0 0 1 1; 0.333 0 0.667 1; 0.333 0 0.667 1; 0.333 0 0.667 1; 0.333 0 0.667 1; 0.333 0 0.667 1",
    fill: "freeze"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "scale(0.9,0.9)"
  }, /*#__PURE__*/React.createElement("animateTransform", {
    repeatCount: "indefinite",
    type: "scale",
    attributeName: "transform",
    dur: "6.017s",
    begin: "0s",
    calcMode: "spline",
    values: "0.9 0.9; 0.9 0.9; 1 1; 0.9 0.9; 1 1",
    keyTimes: "0; 0.501385; 1; 1; 1",
    keySplines: "0 0 1 1; 0.333 0 0.667 1; 0.333 0 0.667 1; 0.333 0 0.667 1",
    fill: "freeze"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-84.5,-76)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,63.901,19.141)",
    id: "i22"
  }, /*#__PURE__*/React.createElement("g", {
    id: "i22"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#7396ff",
    d: "M-5.802,4.314C-6.832,4.314,-7.802,3.704,-8.202,2.684C-8.722,1.364,-8.082,-0.136,-6.752,-0.666C-2.882,-2.206,1.168,-3.416,5.278,-4.266C6.678,-4.546,8.038,-3.656,8.328,-2.256C8.618,-0.856,7.718,0.504,6.318,0.794C2.498,1.584,-1.262,2.704,-4.852,4.134C-5.162,4.254,-5.482,4.314,-5.802,4.314"
  }))))))))), _g21 || (_g21 = /*#__PURE__*/React.createElement("g", {
    id: "i12"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(289,193)"
  }, /*#__PURE__*/React.createElement("animateTransform", {
    repeatCount: "indefinite",
    type: "translate",
    attributeName: "transform",
    dur: "6.017s",
    begin: "0s",
    calcMode: "spline",
    values: "289 193; 289 193; 309 133; 289 193; 299 133",
    keyTimes: "0; 0.501385; 1; 1; 1",
    keySplines: "0 0 1 1; 0.333 0 0.667 1; 0.333 0 0.667 1; 0.333 0 0.667 1",
    fill: "freeze"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(2.356)"
  }, /*#__PURE__*/React.createElement("animateTransform", {
    repeatCount: "indefinite",
    type: "rotate",
    attributeName: "transform",
    dur: "6.017s",
    begin: "0s",
    calcMode: "spline",
    values: "5; 5; -5; 5; -5; 5; -5",
    keyTimes: "0; 0.418283; 0.66482; 0.916898; 1; 1; 1",
    keySplines: "0 0 1 1; 0.333 0 0.667 1; 0.333 0 0.667 1; 0.333 0 0.667 1; 0.333 0 0.667 1; 0.333 0 0.667 1",
    fill: "freeze"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "scale(0.9,0.9)"
  }, /*#__PURE__*/React.createElement("animateTransform", {
    repeatCount: "indefinite",
    type: "scale",
    attributeName: "transform",
    dur: "6.017s",
    begin: "0s",
    calcMode: "spline",
    values: "0.9 0.9; 0.9 0.9; 1 1; 0.9 0.9; 1 1",
    keyTimes: "0; 0.501385; 1; 1; 1",
    keySplines: "0 0 1 1; 0.333 0 0.667 1; 0.333 0 0.667 1; 0.333 0 0.667 1",
    fill: "freeze"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-84.5,-76)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,28.986,72.487)",
    id: "i23"
  }, /*#__PURE__*/React.createElement("g", {
    id: "i23"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#7396ff",
    d: "M-6.869,46.005C-7.809,46.005,-8.719,45.485,-9.179,44.585C-11.989,38.985,-14.069,33.015,-15.339,26.825C-20.999,-0.655,-9.989,-29.045,12.721,-45.515C13.871,-46.355,15.481,-46.095,16.321,-44.935C17.151,-43.785,16.901,-42.175,15.741,-41.335C-5.329,-26.055,-15.539,0.285,-10.289,25.775C-9.109,31.525,-7.179,37.075,-4.569,42.265C-3.929,43.535,-4.439,45.085,-5.709,45.725C-6.089,45.915,-6.479,46.005,-6.869,46.005"
  }))))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg404Animation);
export default __webpack_public_path__ + "static/media/404 Animation.0de31fd25276459b7df6ff2c138bff47.svg";
export { ForwardRef as ReactComponent };